const CAROUSEL_ITEMS = [
  {
    id: 1,
    title: '韩漫恋爱特辑',
    subtitle: '甜蜜心动TOP20',
    desc: '精选二十部口碑爆棚的韩漫恋爱佳作，从校园纯爱到成人浪漫，每一部都值得收藏追更。下拉式阅读带来沉浸式恋爱体验，甜到心坎里。',
    color: 'from-pink-100/60 to-rose-50/60',
    accent: 'bg-pink-50 text-pink-600',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20romantic%20Korean%20webtoon%20style%20illustration%20with%20couple%20in%20cherry%20blossom%20scene%20soft%20pastel%20warm%20lighting%20elegant%20aesthetic%20clean%20cream%20background%20highly%20stylized%20artistic%20editorial&width=700&height=440&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '国漫热血精选',
    subtitle: '燃爆全场的30部力作',
    desc: '从都市修仙到异界冒险，国漫热血题材全面爆发。99漫画为你精选三十部高分国漫，下拉式阅读感受满屏战斗激情。',
    color: 'from-red-100/50 to-orange-50/60',
    accent: 'bg-red-50 text-red-600',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Chinese%20manhua%20action%20illustration%20with%20martial%20arts%20fighter%20in%20epic%20battle%20pose%20dramatic%20energy%20effects%20warm%20orange%20and%20coral%20tones%20clean%20cream%20background%20highly%20stylized%20artistic&width=700&height=440&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '日漫经典殿堂',
    subtitle: '不可错过的传奇名作',
    desc: '收录日漫历史上最具影响力的经典作品全集，从热血王道到治愈日常，下拉式阅读重温那些感动过无数人的名场面。',
    color: 'from-amber-100/50 to-yellow-50/60',
    accent: 'bg-amber-50 text-amber-600',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20classic%20style%20illustration%20with%20iconic%20hero%20characters%20epic%20adventure%20scene%20warm%20nostalgic%20tone%20golden%20sunset%20lighting%20clean%20cream%20background%20highly%20stylized%20artistic&width=700&height=440&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '悬疑推理专场',
    subtitle: '烧脑反转必看系列',
    desc: '韩漫悬疑推理题材强势崛起，烧脑剧情搭配反转结局让人欲罢不能。下拉式阅读一刷到底，体验智商碾压的快感。',
    color: 'from-purple-100/50 to-indigo-50/60',
    accent: 'bg-purple-50 text-purple-600',
    image: 'https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20webtoon%20style%20illustration%20with%20dark%20atmospheric%20scene%20silhouette%20figures%20dramatic%20lighting%20moody%20warm%20undertones%20clean%20cream%20background%20highly%20stylized%20artistic&width=700&height=440&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '新番追更日历',
    subtitle: '每日更新时刻表',
    desc: '整理热门连载漫画的每日更新时间表，追更不用等。韩漫日漫国漫更新一目了然，收藏后第一时间获取更新提醒。',
    color: 'from-green-100/50 to-emerald-50/60',
    accent: 'bg-green-50 text-green-600',
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20modern%20calendar%20and%20schedule%20illustration%20with%20comic%20book%20elements%20warm%20coral%20accents%20organized%20layout%20aesthetic%20clean%20cream%20background%20highly%20stylized%20artistic&width=700&height=440&seq=carousel-05&orientation=landscape',
  },
  {
    id: 6,
    title: '完结全集专区',
    subtitle: '一口气刷完的爽快',
    desc: '收录已完结的韩漫日漫国漫全集资源，无需等待连载更新，下拉式阅读一口气刷到大结局。收藏佳作不容错过。',
    color: 'from-teal-100/50 to-cyan-50/60',
    accent: 'bg-teal-50 text-teal-600',
    image: 'https://readdy.ai/api/search-image?query=A%20complete%20collection%20bookshelf%20illustration%20with%20colorful%20comic%20volumes%20neatly%20organized%20warm%20cozy%20lighting%20library%20atmosphere%20clean%20cream%20background%20highly%20stylized%20artistic&width=700&height=440&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            六大精选漫画专题，一站式发现最值得阅读的漫画作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {CAROUSEL_ITEMS.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className={`group bg-gradient-to-br ${item.color} border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer flex flex-col`}
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <div className="flex items-center gap-2 mb-2">
                  <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${item.accent}`}>
                    {item.subtitle}
                  </span>
                </div>
                <h3 className="text-base font-heading text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed flex-1">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}